import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Hours_24 } from "../../../../../../enums/GlobalEnums";
import {
  Select,
  Switch,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
} from "@material-ui/core";

const useStyles = makeStyles({
  switchBase: {
    color: "#212121",
    "&$checked": {
      color: "#7fff00",
    },
    "&$checked + $track": {
      backgroundColor: "#cccccc",
    },
  },
  checked: {},
  track: {},
});

const MassCompletion = (props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <hr className="mt-5 mb-5" />
      <h5 className="f18-700">Mass Completion</h5>
      <p className="f11-400 opacity5">
        Manage Sessions for mass completion of Seating/Ordering requests
      </p>
      <div className="d-flex align-items-center justify-content-between mt-4 mb-5">
        <div className="w-75">
          <h5 className="f14-500">Run Sessions Automatically</h5>
          <p className="f11-400 opacity5 w-75">
            All the Seating/Ordering/Experience requests will be mass completed
            automatically at a the given time
          </p>
        </div>
        <div className="w-25 d-flex align-items-center">
          <div
            className={`${
              props.massCompletionValue ? "f12-400" : "f12-700"
            } mr-2`}
          >
            No
          </div>
          <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
              root: classes.root,
              switchBase: classes.switchBase,
              thumb: classes.thumb,
              track: classes.track,
              checked: classes.checked,
            }}
            onChange={props.MassCompletionToggle}
            checked={props?.massCompletionValue}
          />
          <div
            className={`${
              props.massCompletionValue ? "f12-700" : "f12-400"
            } ml-2`}
          >
            Yes
          </div>
        </div>
      </div>
      {props.massCompletionValue ? (
        <div className="row mb-4">
          <div className={"col-12 d-flex align-items-center"}>
            <h5 className="f12-500 mr-4">Suggestive Time</h5>
            <div className="w-25">
              {/* <TextField
                id="eventMassCompletionTime"
                label="Select Time"
                variant="outlined"
                type="time"
                className={`w-100`}
                InputLabelProps={{
                  shrink: true,
                }}
                name="eventMassCompletionTime"
                onChange={props.handleChange}
                value={props?.massCompletionTime}
                Select
                Time
              />
              <p className="f11-400 opacity5">
                Select time as per your convenience
              </p> */}
              <FormControl variant="outlined" className={`w-100`}>
                <InputLabel id="timings">Time</InputLabel>
                <Select
                  id="massCompletionTime"
                  label="Timings"
                  labelId="timings"
                  name="massCompletionTime"
                  onChange={props.handleChange}
                  value={props?.massCompletionTime}
                >
                  {Hours_24.map((data, index) => (
                    <MenuItem key={index} value={`${data}`}>
                      {data}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default MassCompletion;
